module.exports = __webpack_public_path__ + "ac679c03720fd0f235c47b45fe523d19.png";